"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchConfigure = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var papaparse_1 = __importDefault(require("papaparse"));
var useSearchDebounce_1 = require("../../../../../hooks/useSearchDebounce");
var branch_1 = require("../../../../../reducers/slices/branch/branch");
var branch_list_thunk_1 = require("../../../../../reducers/slices/branch/thunks/get/branch_list_thunk");
var pages_1 = require("../../../../../constants/pages");
var product_1 = require("../../../../../reducers/slices/products/product");
var create_procurement_thunk_1 = require("../../../../../reducers/slices/products/thunks/create_procurement_thunk");
var get_client_procurements_thunk_1 = require("../../../../../reducers/slices/products/thunks/get_client_procurements_thunk");
var get_procurement_products_thunk_1 = require("../../../../../reducers/slices/products/thunks/get_procurement_products_thunk");
var check_stock_1 = require("../../../../../api/calls/product/procurement/check_stock");
var BranchConfigure = function (args) {
    var _a, _b;
    var getSuppliers = args.getSuppliers;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, useSearchDebounce_1.useSearchDebounce)(), branchSearch = _c[0], setBranchSearch = _c[1];
    var _d = (0, react_1.useState)(), branch = _d[0], setBranch = _d[1];
    var _e = (0, react_1.useState)(), procurementHistory = _e[0], setProcurementHistory = _e[1];
    var _f = (0, react_1.useState)(true), fromCSV = _f[0], setFromCSV = _f[1];
    var _g = (0, react_1.useState)([]), products = _g[0], setProducts = _g[1];
    var _h = (0, react_1.useState)([]), selectedProducts = _h[0], setSelectedProducts = _h[1];
    var _j = (0, react_1.useState)(false), isLoading = _j[0], setIsLoading = _j[1];
    var _k = (0, react_redux_1.useSelector)(function (state) { return state.branchState; }), branches = _k.branches, pagination = _k.pagination;
    var _l = (0, react_redux_1.useSelector)(function (state) { return state.productState; }), procureProducts = _l.procureProducts, currentProcurement = _l.currentProcurement, clientProcurements = _l.clientProcurements, procurementProductsPagination = _l.procurementProductsPagination, loading = _l.loading;
    (0, react_1.useEffect)(function () {
        var extensibleProducts = procureProducts.map(function (x) {
            return __assign({}, x);
        });
        setProducts(extensibleProducts);
        setSelectedProducts(extensibleProducts);
    }, [procureProducts]);
    (0, react_1.useEffect)(function () {
        getBranch();
    }, [branchSearch]);
    (0, react_1.useEffect)(function () {
        if (procurementHistory === null || procurementHistory === void 0 ? void 0 : procurementHistory._id)
            getProcurementProducts({});
    }, [procurementHistory]);
    (0, react_1.useEffect)(function () {
        var _pagination = __assign({}, pagination);
        _pagination === null || _pagination === void 0 ? true : delete _pagination.countTotal;
        dispatch((0, get_client_procurements_thunk_1.get_client_procurements_thunk)({ payload: __assign({}, _pagination) }));
    }, []);
    var getProcurementProducts = function (filter) {
        var _procurementProductsPagination = __assign({}, procurementProductsPagination);
        delete _procurementProductsPagination.countTotal;
        dispatch((0, get_procurement_products_thunk_1.get_procurement_products_thunk)({
            payload: __assign(__assign(__assign({}, _procurementProductsPagination), filter), { procurement_id: procurementHistory === null || procurementHistory === void 0 ? void 0 : procurementHistory._id }),
            callback: function (products) {
                dispatch((0, product_1.setProcureProducts)(products.map(function (product) {
                    return {
                        title: product.title,
                        sku: product.sku,
                        quantity: product.quantity,
                    };
                })));
                dispatch((0, create_procurement_thunk_1.create_procurement_thunk)({
                    payload: {
                        branch_id: branch._id,
                        branch: {
                            _id: branch._id,
                            display_name: branch.display_name,
                        },
                    },
                }));
            },
        }));
    };
    var getBranch = function () {
        dispatch((0, branch_list_thunk_1.branch_list_thunk)(__assign(__assign({}, pagination), { search_string: branchSearch !== null && branchSearch !== void 0 ? branchSearch : "" })));
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4 mt-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "bg-white p-4" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.DropdownSearchControl, { renderDisplay: function (x) { return x === null || x === void 0 ? void 0 : x.label; }, label: "Search for a branch.", options: (_a = branches === null || branches === void 0 ? void 0 : branches.map(function (x) { return (__assign({ label: x === null || x === void 0 ? void 0 : x.display_name, value: x === null || x === void 0 ? void 0 : x._id }, x)); })) !== null && _a !== void 0 ? _a : [], size: "small", value: branch, colors: {
                        borderColor: "border-borders",
                        textColor: "text-slate-400",
                        labelColor: "text-slate-400",
                        iconColor: "text-slate-400",
                    }, errorText: "", onChange: function (data) {
                        setBranch(data);
                        dispatch((0, branch_1.setSelectedBranch)(data));
                    }, onSearchChanged: function (search_string) {
                        setBranchSearch(search_string);
                    } }) })), (branch === null || branch === void 0 ? void 0 : branch._id) && (clientProcurements === null || clientProcurements === void 0 ? void 0 : clientProcurements.length) > 0 && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "bg-white p-4" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.DropdownSearchControl, { renderDisplay: function (x) { return x === null || x === void 0 ? void 0 : x.label; }, label: "Select a Procurement history.", options: (_b = clientProcurements === null || clientProcurements === void 0 ? void 0 : clientProcurements.map(function (x) {
                                var _a;
                                return (__assign({ label: "".concat((_a = x === null || x === void 0 ? void 0 : x.branch) === null || _a === void 0 ? void 0 : _a.display_name, " - ").concat(doshx_controls_web_1.Utilities.formatDateTime(x === null || x === void 0 ? void 0 : x.createdAt, "YYYY-MM-DD")), value: x === null || x === void 0 ? void 0 : x._id }, x));
                            })) !== null && _b !== void 0 ? _b : [], size: "small", value: procurementHistory, colors: {
                                borderColor: "border-borders",
                                textColor: "text-slate-400",
                                labelColor: "text-slate-400",
                                iconColor: "text-slate-400",
                            }, errorText: "", onChange: function (data) {
                                setFromCSV(false);
                                setProcurementHistory(data);
                            }, onSearchChanged: function (search_string) {
                                //setBranchSearch(search_string);
                            } }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "OR", bold: true }) }))] }))), (branch === null || branch === void 0 ? void 0 : branch._id) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: " bg-white p-4" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.FileInputControl, { label: "Upload your product list (.csv,.xlsx,.xls)", size: "medium", onChange: function (f) {
                        console.log("FileInputControl onChange", f);
                        if (f) {
                            console.log(f);
                            var jsonData_1 = [];
                            papaparse_1.default.parse(f, {
                                complete: function (results) {
                                    var resultsJson = results.data;
                                    if (resultsJson.length > 0) {
                                        for (var i = 1; i < resultsJson.length; i++) {
                                            var line = {};
                                            if (resultsJson[i].length > 1) {
                                                for (var j = 0; j < resultsJson[0].length; j++) {
                                                    var keys = resultsJson[0];
                                                    var values = resultsJson[i];
                                                    line[keys[j]] = values[j];
                                                }
                                                jsonData_1.push(line);
                                            }
                                        }
                                    }
                                    setFromCSV(true);
                                    dispatch((0, product_1.setProcureProducts)(jsonData_1));
                                    dispatch((0, create_procurement_thunk_1.create_procurement_thunk)({
                                        payload: {
                                            branch_id: branch._id,
                                            branch: {
                                                _id: branch._id,
                                                display_name: branch.display_name,
                                            },
                                        },
                                    }));
                                },
                            });
                        }
                    }, previewSide: "right", previewFile: true }) }))), (procureProducts === null || procureProducts === void 0 ? void 0 : procureProducts.length) > 0 && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: loading ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "grid justify-center p-4" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl, { size: "large" }) }))) : ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.TableControl, { columns: [
                                {
                                    displayKey: "title",
                                    label: "Title",
                                },
                                {
                                    displayKey: "sku",
                                    label: "SKU",
                                },
                                {
                                    displayKey: "quantity",
                                    label: "Quantity",
                                    formatter: function (product) {
                                        return ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: "Quantity", borderColor: "border-borders", value: product.quantity, size: "small", onChange: function (v) { return __awaiter(void 0, void 0, void 0, function () {
                                                var _p, _sp;
                                                return __generator(this, function (_a) {
                                                    _p = products.map(function (x) {
                                                        if (x.sku === product.sku)
                                                            return __assign(__assign({}, x), { quantity: v });
                                                        return x;
                                                    });
                                                    _sp = selectedProducts.map(function (x) {
                                                        if (x.sku === product.sku)
                                                            return __assign(__assign({}, x), { quantity: v });
                                                        return x;
                                                    });
                                                    setProducts(_p);
                                                    setSelectedProducts(_sp);
                                                    return [2 /*return*/];
                                                });
                                            }); } }));
                                    },
                                },
                            ], rowSelections: selectedProducts, onSelectionChange: function (selectedRows) {
                                setSelectedProducts(selectedRows);
                            }, data: products, hasShadow: true, pagination: {
                                currentPage: procurementProductsPagination.page,
                                rowsPerPage: fromCSV ? products.length : procurementProductsPagination.size,
                                totalRecords: procurementProductsPagination.countTotal,
                                onPageChange: function (page) {
                                    if (fromCSV) {
                                    }
                                    else {
                                        getProcurementProducts({ page: page });
                                    }
                                },
                                onRowsPerPageChange: function (size) {
                                    if (fromCSV) {
                                    }
                                    else {
                                        getProcurementProducts({ size: size });
                                    }
                                },
                            }, colors: pages_1.tableColorConfig }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-center items-center gap-2" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Search for stock", size: "small", shape: "square", loading: isLoading, backgroundColor: "bg-success", onClick: function () {
                                    setIsLoading(true);
                                    dispatch((0, product_1.setProcureProducts)(products));
                                    (0, check_stock_1.check_stock)({
                                        procurement_id: currentProcurement._id,
                                        products: products,
                                    }).then(function (res) {
                                        setIsLoading(false);
                                        if (res.success) {
                                            getSuppliers();
                                        }
                                    });
                                } }) }))] }))) }))] })));
};
exports.BranchConfigure = BranchConfigure;
